import { preT } from "../../util/i18n";
import { IconButton } from "../TooltipControls";
import { TH } from "./MyTable";
import SortIndicator from "./SortIndicator";
import * as _ from "lodash";
import * as React from "react";
import More from "../More";
function nextDirection(direction) {
    switch (direction) {
        case "asc":
            return "desc";
        default:
            return "asc";
    }
}
function nop() {
    // nop
}
class HeaderCell extends React.Component {
    mMinWidth = -1;
    mRef = null;
    shouldComponentUpdate(newProps) {
        // TODO: state is a new object every call, needs to be fixed in Table.tsx
        return (this.props.attribute !== newProps.attribute ||
            !_.isEqual(this.props.state, newProps.state) ||
            this.props.doFilter !== newProps.doFilter ||
            this.props.doGroup !== newProps.doGroup ||
            this.props.children !== newProps.children);
    }
    render() {
        const { t, attribute, className, doFilter } = this.props;
        const style = {};
        if (this.mMinWidth >= 0) {
            style["minWidth"] = this.mMinWidth;
        }
        return (React.createElement(TH, { className: `table-header-cell ${className}`, key: attribute.id, domRef: this.setRef, style: style },
            React.createElement("div", { style: { display: "flex", flexDirection: "column" } },
                React.createElement("div", { className: "flex-fill", style: { display: "flex", flexDirection: "row" }, onClick: this.cycleDirection },
                    React.createElement("div", { style: { margin: 0, display: "flex", alignItems: "center" } },
                        preT(t, attribute.name),
                        attribute.help !== undefined ? (React.createElement(More, { id: `more-${attribute.name}`, name: preT(t, attribute.name) }, preT(t, attribute.help))) : null),
                    React.createElement("div", { className: "cell-controls" },
                        attribute.isSortable ? this.renderSortIndicator() : React.createElement("div", null),
                        attribute.isGroupable ? this.renderGroupIndicator() : null)),
                doFilter ? this.props.children : null)));
    }
    updateWidth() {
        if (this.mRef !== null) {
            if (this.mRef.clientWidth > this.mMinWidth) {
                this.mMinWidth = this.mRef.clientWidth;
            }
        }
    }
    renderGroupIndicator() {
        const { t, doGroup } = this.props;
        const classes = ["btn-embed"];
        classes.push(doGroup ? "table-group-enabled" : "table-group-disabled");
        return (React.createElement(IconButton, { icon: "layout-list", onClick: this.setGroup, tooltip: t("Group the table by this attribute"), className: classes.join(" "), tabIndex: -1 }));
    }
    renderSortIndicator() {
        const { state } = this.props;
        const direction = state?.sortDirection ?? "none";
        return (React.createElement(SortIndicator, { direction: direction, onSetDirection: this.setDirection }));
    }
    setRef = (ref) => {
        this.mRef = ref;
    };
    cycleDirection = (evt) => {
        const { attribute, onSetSortDirection, state } = this.props;
        if (evt.defaultPrevented) {
            return;
        }
        if (attribute.isSortable) {
            const direction = state?.sortDirection ?? "none";
            onSetSortDirection(attribute.id, nextDirection(direction));
        }
    };
    setGroup = (evt) => {
        const { onSetGroup, attribute } = this.props;
        onSetGroup(attribute.id);
        evt.preventDefault();
    };
    setDirection = (dir) => {
        const { attribute, onSetSortDirection } = this.props;
        onSetSortDirection(attribute.id, dir);
    };
}
export default HeaderCell;
